export default "<p-breadcrumb [home]=\"home\" [model]=\"menuItems\"></p-breadcrumb>\n"